import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Grid from 'apollo-react/components/Grid';
import HcpSignupPageFrame from './HcpSignupPageFrame';
import { getSignupDraft, HCP_SIGNUP_DRAFT_STORAGE_KEY } from './hcpSignupApi';
import { deriveResumeSignupPath } from './hcpSignupFlowUtils';

/** Landing route: restores local draft pointer and redirects to last incomplete wizard step. */
export default function HcpSignupResumeEntry() {
  const navigate = useNavigate();
  const [hint, setHint] = useState('Resuming sign-up…');

  useEffect(() => {
    let cancel = false;
    (async () => {
      const raw = window.localStorage.getItem(HCP_SIGNUP_DRAFT_STORAGE_KEY);
      const id = raw ? parseInt(raw, 10) : NaN;
      if (Number.isNaN(id)) {
        if (!cancel) navigate('/hcp-signup/step-1', { replace: true });
        return;
      }

      try {
        const res = await getSignupDraft(id);
        if (cancel) return;
        if (!res?.success || !res.data?.draftId) {
          window.localStorage.removeItem(HCP_SIGNUP_DRAFT_STORAGE_KEY);
          navigate('/hcp-signup/step-1', { replace: true });
          return;
        }
        navigate(deriveResumeSignupPath(res.data), { replace: true });
      } catch {
        if (!cancel) {
          setHint('Could not load your draft. Starting from step 1.');
          setTimeout(() => {
            navigate('/hcp-signup/step-1', { replace: true });
          }, 800);
        }
      }
    })();
    return () => {
      cancel = true;
    };
  }, [navigate]);

  return (
    <HcpSignupPageFrame>
      <Grid container justifyContent="center" className="signInTitleGrid">
        <p className="signInDesc">{hint}</p>
      </Grid>
    </HcpSignupPageFrame>
  );
}
